import { SnippetSchemaEnvironmentSampleFile } from '../code-selector/code-snippets/interfaces'
import { CodeSelectorOption } from '../code-selector/interfaces'
import {
  CheckoutSimulatorParametersProps,
  CheckoutSimulatorState,
} from './interfaces'

type CheckoutSimulatorAction =
  | {
      type: '[Checkout_Simulator] Set option value'
      payload: {
        name: string
        value: string
      }
    }
  | {
      type: '[Checkout_Simulator] Set buttons options'
      payload: CodeSelectorOption[]
    }
  | {
      type: '[Checkout_Simulator] Set integration type'
      payload: {
        integrationType: string
      }
    }
  | {
      type: '[Checkout_Simulator] Set snippets'
      payload: { [environment: string]: SnippetSchemaEnvironmentSampleFile[] }
    }
  | {
      type: '[Checkout_Simulator] Set parameters'
      payload: CheckoutSimulatorParametersProps
    }
  | {
      type: '[Checkout_Simulator] Set parameter'
      payload: {
        name: string
        value: any
      }
    }

export const checkoutSimulatorReducer = (
  state: CheckoutSimulatorState,
  action: CheckoutSimulatorAction,
): CheckoutSimulatorState => {
  switch (action.type) {
    case '[Checkout_Simulator] Set option value':
      return {
        ...state,
        options: [
          ...state.options.map((option) =>
            option.name === action.payload.name
              ? {
                  ...option,
                  value: action.payload.value,
                }
              : option,
          ),
        ],
      }
    case '[Checkout_Simulator] Set integration type':
      return {
        ...state,
        integrationType: action.payload.integrationType,
      }
    case '[Checkout_Simulator] Set buttons options':
      return {
        ...state,
        options: action.payload,
      }
    case '[Checkout_Simulator] Set snippets':
      return {
        ...state,
        snippets: action.payload,
      }
    case '[Checkout_Simulator] Set parameters':
      return {
        ...state,
        parameters: action.payload,
      }
    case '[Checkout_Simulator] Set parameter':
      return {
        ...state,
        parameters: {
          ...state.parameters,
          [action.payload.name]: action.payload.value,
        },
      }
    default:
      return state
  }
}
